var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_76521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.00033,
    cy: 6.99999,
    r: 5.83333,
    stroke: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10143 5.79532C8.72847 6.30683 9.04199 6.56259 9.04199 7.00002C9.04199 7.43745 8.72847 7.69321 8.10143 8.20472C7.92833 8.34592 7.75665 8.47887 7.59889 8.58965C7.46049 8.68684 7.30374 8.78737 7.14145 8.88606C6.51589 9.26647 6.2031 9.45668 5.92257 9.24609C5.64203 9.0355 5.61654 8.59465 5.56555 7.71294C5.55113 7.4636 5.54199 7.21916 5.54199 7.00002C5.54199 6.78089 5.55113 6.53645 5.56555 6.2871C5.61654 5.40539 5.64203 4.96454 5.92257 4.75395C6.2031 4.54336 6.51589 4.73357 7.14145 5.11398C7.30374 5.21267 7.46048 5.3132 7.59889 5.41039C7.75665 5.52117 7.92833 5.65412 8.10143 5.79532Z",
    stroke: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_76521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.54778a030a1b541145741091d8aa54d1.svg";
export { ForwardRef as ReactComponent };